module.exports = __webpack_public_path__ + "img/rightFlower@2x.dc3bda62.png";